import { certificates } from "../data/site";
import { Develop, Reveal } from "./motion";

export default function Credentials() {
  return (
    <section className="section credentials" id="credentials">
      <div className="shell">
        <Reveal>
          <p className="label">Credentials</p>
          <h2 className="h2 credentials__heading">
            {certificates.length} certificates, and the reading that came with
            them.
          </h2>
          <p className="soft measure credentials__note">
            Drag sideways. Each one opens the original document.
          </p>
        </Reveal>
      </div>

      {/* Native scroll-snap rail. No carousel library, no arrows to maintain. */}
      <ul className="rail">
        {certificates.map((cert) => (
          <li className="rail__item" key={cert.href}>
            <a href={cert.href} target="_blank" rel="noreferrer" className="card">
              <div className="card__frame">
                <Develop src={cert.image} alt={`${cert.title} certificate`} className="card__img" />
              </div>
              <div className="card__foot">
                <span className="card__title">{cert.title}</span>
                {cert.issuer && <span className="label">{cert.issuer}</span>}
              </div>
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
}
